import React, { ReactElement, useState } from 'react'
import StepTitle from '../StepTitle'
import { IStepProps } from '../../interfaces/Step'
import Step5Form from './Step5Form'
import TooltipWrapper from '../tooltips/TooltipWrapper'
import Step5Tooltip from '../tooltips/Step5Tooltip'
import ButtonAddMore from '../ButtonAddMore'
import SubmitButton from '../SubmitButton'
import useStep5Hook from '../../hooks/useStep5Hook'

function Step5(props: IStepProps): ReactElement {
  const {
    form,
    handleNextStep,
    setShowSecondForm,
    showSecondForm,
    onSubmit,
    state,
    stepUploadFileProps,
    addState,
    removeState,
    fiscalCountriesList,
    folderData,
    addressStatus,
    countriesStatus,
    address,
  } = useStep5Hook(props)

  const [isLoadingForm, setIsLoadingForm] = useState(false)

  const { title } = props
  const { handleSubmit } = form

  return (
    <>
      <StepTitle title={title}>
        <TooltipWrapper title="Pourquoi ces informations ?">
          <Step5Tooltip />
        </TooltipWrapper>
      </StepTitle>

      <form onSubmit={handleSubmit(onSubmit)}>
        <Step5Form
          stepUploadFileProps={stepUploadFileProps}
          {...props}
          state={state}
          form={form}
          addState={addState}
          removeState={removeState}
          setIsLoadingForm={setIsLoadingForm}
          fiscalCountriesList={fiscalCountriesList}
          folderData={folderData}
          addressStatus={addressStatus}
          countriesStatus={countriesStatus}
          address={address}
        />
        {showSecondForm && (
          <Step5Form
            fiscalCountriesList={fiscalCountriesList}
            stepUploadFileProps={stepUploadFileProps}
            {...props}
            state={state}
            form={form}
            setShowSecondForm={setShowSecondForm}
            item={2}
            addState={addState}
            removeState={removeState}
            setIsLoadingForm={setIsLoadingForm}
            folderData={folderData}
            addressStatus={addressStatus}
            countriesStatus={countriesStatus}
            address={address}
          />
        )}
        <div className="dFlexMd justifyContentBetween alignItemsCenter">
          {!isLoadingForm && (
            <ButtonAddMore
              label="Ajouter une autre résidence fiscale"
              handleClick={() => setShowSecondForm(true)}
              type="button"
              disabled={showSecondForm}
            />
          )}
          <div className="textRight mlAuto">
            <SubmitButton label="Étape suivante" onClick={handleNextStep} />
          </div>
        </div>
      </form>
    </>
  )
}

export default Step5
